<template>
  <div
    id="vendors-bids-attachment"
    class="vendor-attachment"
  >
    <ul
      id="vendors-bids-attachment-accordion"
      class="accordion"
      data-accordion
      data-multi-expand="true"
      data-allow-all-closed="true"
    >
      <li
        id="vendors-bids-attachment-hkld-panel"
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('tender.tenderAttachment') }}</a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <attachments
            :files.sync="engineerFiles"
            :showTenderHints="true"
            :zipName="`${zipPrefix}_Attachments.zip`"
          />
        </div>
      </li>
      <li
        v-if="editView"
        id="vendors-bids-attachment-vendor-panel"
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('vendor.attachment.vendor') }}</a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <pre>
            <p
              v-show="attachmentDesc"
              class="upload-instructions"
            >{{ attachmentDesc }}</p>
          </pre>
          <FileUpload
            :attachment.sync="attachment"
            :resourceId="tenderBidId"
          />
        </div>
      </li>
      <li
        v-if="!editView"
        id="vendors-bids-attachment-hkld-panel"
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('vendor.attachment.vendor') }}</a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <p
            v-show="attachmentDesc"
            class="upload-instructions"
          >
            {{ attachmentDesc }}
          </p>
          <attachments
            :files.sync="vendorFiles"
            :noHighlight="true"
            :zipName="`${zipPrefix}_Vendor_Attachments.zip`"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FileUpload from '@/modules/FileUpload'
import HTTP from '@/utils/http'
import Attachments from '@/modules/tenders/view/Attachments'

export default {
  name: 'TenderBidAttachments',
  components: {
    FileUpload, Attachments,
  },
  props: {
    attachment: {
      type: Object,
    },
    attachmentDesc: {
      type: String,
    },
    tenderId: {
      type: String,
    },
    editView: {
      type: Boolean,
      default: true,
    },
    tenderBidId: {
      type: String,
    },
    zipPrefix: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      vendorFiles: [],
    }
  },
  methods: {
    async loadVendorFiles () {
      if (!this.editView && this.tenderBidId) {
        const response = await HTTP.get(`/docs/?src=${this.tenderBidId}`)
        this.vendorFiles = response.data.data
      }
    },
  },
  mounted () {
    if (!this.attachmentAccordion) {
      this.attachmentAccordion = new Foundation.Accordion($('[id^=vendors-bids-attachment-accordion]'))
    }
    if (this.tenderBidId) {
      this.loadVendorFiles()
    }
  },
  destroyed () {
    if (this.attachmentAccordion) {
      this.attachmentAccordion.destroy()
    }
  },
  watch: {
    tenderBidId () {
      this.loadVendorFiles()
    },
  },
  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
    }),
    engineerFiles () {
      return deep(this.currentTender, 'general.documents') || this.attachment.files || []
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/accordion';

.upload-instructions {
  font-family: Verdana;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #0C3A58;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>
